import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="relative h-[300px] md:h-[400px] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20creative%20workspace%20top%20view%20featuring%20an%20open%20laptop%20with%20colorful%20spreadsheet%20charts%20on%20screen%20surrounded%20by%20curated%20fashion%20pieces%20including%20a%20textured%20beige%20knit%20sweater%20folded%20olive%20trousers%20brown%20leather%20loafers%20and%20a%20steaming%20ceramic%20coffee%20mug%20on%20warm%20oak%20wood%20desk%20natural%20daylight%20through%20nearby%20window%20with%20trailing%20ivy%20plant%20editorial%20lifestyle%20aesthetic&width=800&height=600&seq=kakobuy-about-img-v3-02&orientation=landscape"
              alt="Czym jest Kakobuy Spreadsheet - zorganizowana baza produktów"
              title="Kakobuy Spreadsheet – zorganizowana baza produktów"
              className="w-full h-full object-cover"
            />
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-semibold text-foreground-950 mb-4">
              Czym jest Kakobuy Spreadsheet?
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              Kakobuy Spreadsheet to uporządkowana baza produktów, która pomaga użytkownikom szybciej znaleźć interesujące produkty, porównać opcje i zaoszczędzić czas podczas zakupów online.
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              To kompleksowe narzędzie, które łączy w sobie listy produktów, porównania cen oraz informacje o dostępności. Dzięki regularnym aktualizacjom, każdy użytkownik z Polski może podejmować świadome decyzje zakupowe bez konieczności przeszukiwania dziesiątek stron internetowych. Baza zawiera setki produktów w różnych kategoriach – od obuwia, przez odzież, aż po akcesoria i perfumy.
            </p>
            <Link
              to="/artykul/kakobuy-spreadsheet-polski-przewodnik"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors"
            >
              Dowiedz się więcej
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}